module.exports = __webpack_public_path__ + "images/12-01@2x_edf20d31.png";